import React from 'react';
import styled from '@emotion/styled';
// import core components
import LoadingGif from '/static/gifs/loading.gif';

const Wrapper = styled.button`
  ${({isMobile}) => isMobile ? 'height: 45px; width: 45px;' : ''}
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({theme}) => theme.colors.black};
  background-color: ${({disabled,theme}) => disabled ? "#EBEBEB": theme.colors.lightBlue};
  visibility: ${({isDisabled}) => isDisabled ? "hidden" : ""};
  width: 130px;
  padding: 13px 0px;
  border-radius: ${({theme}) => theme.borderRadius.round};
  height: fit-content;
  align-items: center;
  &.mobileCircle{
    height: 45px; 
    width: 45px;
    border-radius: 50%;
    background: ${({theme, leftIcon}) => leftIcon ? '#F9F9F9' : theme.colors.lightBlue};
    border: 1px solid #EBEBEB;
  }
  label {
    font-size: 16px;
    font-weight: ${({theme}) => theme.fontWeight.button};
    line-height: 24px;
  }
  ${({isMobile}) => isMobile ? ``:`
  &.enabled:hover {
    cursor: pointer;
    color: ${({theme}) => theme.colors.white};
    background-color: ${({theme, isDisabled}) => isDisabled ? theme.colors.stroke : theme.colors.black};
    color: ${({theme, isDisabled}) => isDisabled ? theme.colors.black : theme.colors.white};
    label{
      cursor: pointer;
    }
  }
  `}
  
  > svg {
    width: 26px;
    height: 18px;
    margin-left: ${({leftIcon}) => leftIcon ? "0px" : "5px"};
    margin-right: ${({leftIcon}) => leftIcon ? "5px" : "0px"};
  }
  .loading-gif {
    width: 26px;
    margin: 0px;
    margin-left: 5px;
  }

  @media (max-width: ${props => props.theme.breakpoints.m}) {

    width: fit-content;
    padding: 10px 15px;
    label {
      display: none;
    }
    svg, .loading-gif {
      margin: 0px;
    }
  }
`;

const StepArrowButton = (
{ icon, 
  leftIcon,
  text,
  handleClick,
  isDisabled,
  className,
  itemId,
  itemPrice,
  itemUrl,
  itemName,
  disabled,
  isMobile
}) => {
  const Icon = icon;
  const classes = [];
  classes.push(disabled ? "disabled" : "enabled");
  classes.push(isMobile ? "mobileCircle" : "");
  return (
    <Wrapper
      leftIcon={leftIcon}
      // isDisabled={isDisabled}
      onClick={handleClick}
      className={className}
      data-item-id={itemId}
      data-item-price={itemPrice}
      data-item-url={itemUrl}
      data-item-name={itemName}
      disabled={disabled}
      //className={classes.join(" ")}
    >
      {disabled ? <>
        <label>{text}</label>
        <img className="loading-gif small" src={LoadingGif} alt="image loading" />
      </> : <>
        {Icon && leftIcon && <Icon />}
        <label>{text}</label>
        {Icon && !leftIcon && <Icon />}
      </>}
    </Wrapper>
  )
};

StepArrowButton.defaultProps = {
  leftIcon: true,
};

export default StepArrowButton;